import {
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import React from "react";
import HouseGallery from "./HouseGallery";
import playButton from "../../../../images/playButton.png";
import { PlayCircle } from "@mui/icons-material";
import { useState } from "react";
import { useRef } from "react";
import ReactPlayer from "react-player";
import "./videoplayer.css";
import GhoramiPlayer from "../../../Custom Hooks/Video Player/GhoramiPlayer";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const GalleryContainer = (props) => {
  const focus = useRef("");
  // const videoRef = useRef(null);

  const { fetchedServicePic, fetchedServiceDetails } = props;
  const [value, setValue] = useState(0);
  const [play, setPlay] = useState(false);
  const [hide, setHide] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const hasMultipleImages = fetchedServicePic && fetchedServicePic.length > 1;
  const isYouTube = fetchedServiceDetails?.service_video_type === "youtube";
  const customVideo =
    fetchedServiceDetails?.service_video_type === "ghorami" ? true : false;

  return (
    <Box sx={{ width: "100%", mt: { xs: "60px", md: 0 } }}>
      {/* Tabs Header */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="Media Tabs">
          <Tab label="Picture" {...a11yProps(0)} sx={{ width: "50%" }} />
          <Tab label="Video" {...a11yProps(1)} sx={{ width: "50%" }} />
        </Tabs>
      </Box>

      {/* Picture Tab */}
      <TabPanel value={value} index={0}>
        {/* <HouseGallery fetchedServicePic={fetchedServicePic} /> */}

        {hasMultipleImages ? (
          <HouseGallery fetchedServicePic={fetchedServicePic} />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%", // or any height depending on your layout
            }}
          >
            <Box
              component="img"
              src={fetchedServicePic?.[0]?.mpic}
              alt="Service Preview"
              sx={{
                width: "auto",
                height: "55vh",
                borderRadius: 2,
                boxShadow: 2,
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              }}
            />
          </Box>
        )}
      </TabPanel>

      {/* Video Tab */}
      <TabPanel value={value} index={1}>
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ position: "relative" }}
        >
          {customVideo ? (
            <Box sx={{ width: "100%" }}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "56.25%" /* 16:9 aspect ratio */,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <GhoramiPlayer
                    // videoUrl="https://ghorami.com/image/ghorami_Intro.mp4"
                    playerHeight="65vh"
                    videoUrl="https://ghorami.com/image/ghorami_Intro.mp4"
                    adUrl="https://ghorami.com/image/ghorami_Intro.mp4"
                    subtitles={[
                      {
                        label: "English",
                        src: "/subs/eng.vtt",
                        srclang: "en",
                        default: true,
                      },
                      { label: "Bangla", src: "/subs/bn.vtt", srclang: "bn" },
                    ]}
                  />
                </div>
              </div>
            </Box>
          ) : (
            <Box sx={{ width: "100%" }}>
              <GhoramiPlayer
                videoUrl={`//yeapbe.com/${fetchedServiceDetails?.videoUrl?.subId}`}
                playerHeight="65vh"
              />
            </Box>
          )}

          {isYouTube && (
            <>
              <ReactPlayer
                width="100%"
                height={isMobile ? "40vh" : "48.5vh"}
                controls
                playing={play}
                url={fetchedServiceDetails?.service_video_url}
              />

              {/* Overlay for YouTube custom play button */}
              {!play && (
                <>
                  <Box
                    onClick={() => setPlay(true)}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: isMobile ? "40vh" : "48.5vh",
                      bgcolor: "rgba(0,0,0,0.3)",
                      zIndex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      borderRadius: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={playButton}
                      alt="Play"
                      sx={{
                        width: 64,
                        height: 64,
                        transition: "transform 0.3s ease",
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                    />
                  </Box>
                </>
              )}
            </>
          )}
        </Stack>
      </TabPanel>
    </Box>
  );
};

export default GalleryContainer;
